import { ReactNode, useMemo, isValidElement } from 'react'
import css from './reportWidget.module.css'
import formatUtils from '@/utils/format.utils'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  title: string
  value: number | string | ReactNode
  loading: boolean
}

const ReportWidget = (props: IProps) => {
  const renderValue = useMemo(() => {
    switch (true) {
      case typeof props.value === 'string':
        return (
          <p className="text-nm" style={{ color: 'var(--text-link)' }}>
            {props.value.length > 0 ? props.value : '-'}
          </p>
        )
      case typeof props.value === 'number':
        return (
          <p className="text-nm" style={{ color: 'var(--text-link)' }}>
            {formatUtils.formatNumber(props.value)}
          </p>
        )
      case isValidElement(props.value):
        return props.value
      default:
        return (
          <p className="text-nm" style={{ color: 'var(--text-link)' }}>
            -
          </p>
        )
    }
  }, [props.value])

  return (
    <div className={css.card}>
      <p className="text-nm text-description">{props.title}</p>
      <Skeleton height="20px" width="32px" style={{ borderRadius: '2px' }} loading={props.loading}>
        {renderValue}
      </Skeleton>
    </div>
  )
}
export default ReportWidget
